import React from 'react'
import { Box, Flex, Container } from 'pcln-design-system'
import HotelsTonight from '@/components/HotelsTonight/HotelsTonight'
import PromoFeatureBox from '@/components/PromoFeatureBox'
import SmsOptIn from '@/components/SmsOptIn'
import ConditionalRender, { Experiment } from '@/components/ConditionalRender'
import useMostRecentFutureBooking from '@/hooks/useMostRecentFutureBooking'
import useExpressDealModal from '@/hooks/useExpressDealModal'
import CrossSell from '@/components/CrossSell'
import { EmailSignUpToast } from '@/components/EmailSignUp'
import MarketingTout from '@/components/Promos/MarketingTout/MarketingTout'
import ExtendStay from '@/components/ExtendStay'
import useExtendStayBooking from '@/hooks/useExtendStayBooking'
import SearchFormProvider from '@/context/SearchFormContext'
import SearchFormMobile from '@/components/SearchForm/SearchFormMobile'
import { SilhouetteMarketingModule } from '@pcln/marketing'
import BRANDED_MARKETING_CONTENT from '@/constants/promotions/branded-marketing'
import { ActionCard } from '@pcln/cards'
import { Bag, Help } from 'pcln-icons'
import useSmsDisclaimerQueryArgs from '@/hooks/smsOptIn/useSmsDisclaimerQueryArgs'
import {
  trackMyTrips,
  trackHelpCenter
} from '@/components/AppDownloadOptIn/utils'
import ExpressDealModal from '@/components/Hotels/ExpressDeal/ExpressDealModal'
import LayoutComponentWrapper from '../LayoutComponentWrapper'

export default function HomeMobile() {
  const { isOpen } = useExpressDealModal()
  const mostRecentFutureBooking = useMostRecentFutureBooking()
  const extendData = useExtendStayBooking()

  const smsDisclaimerQueryArgs = useSmsDisclaimerQueryArgs()

  return (
    <Container>
      <ExpressDealModal isModalOpen={isOpen} />
      <SearchFormProvider>
        <SearchFormMobile />
      </SearchFormProvider>
      <Box m={3}>
        <Box mb={extendData || mostRecentFutureBooking ? 5 : 0}>
          {extendData ? (
            <ExtendStay {...extendData} />
          ) : (
            mostRecentFutureBooking && (
              <CrossSell booking={mostRecentFutureBooking} />
            )
          )}
        </Box>
        <PromoFeatureBox />
      </Box>
      <Box m={3} mt="48px">
        <ConditionalRender experimentCode="HP_SMS_COMPONENT">
          <Experiment>
            <SmsOptIn disclaimerQueryArgs={smsDisclaimerQueryArgs} />
          </Experiment>
        </ConditionalRender>
        <MarketingTout />
      </Box>
      <LayoutComponentWrapper>
        <SilhouetteMarketingModule {...BRANDED_MARKETING_CONTENT} />
      </LayoutComponentWrapper>
      <Box m={3}>
        <HotelsTonight />
        <Box textAlign="center" mt={4} width={1}>
          <div id="div-gpt-ad-1544641976893-0" />
        </Box>
      </Box>
      <ConditionalRender experimentCode="HP_APPBANNER_TRIO">
        <Experiment>
          <Flex m={3} flexDirection="column" style={{ gap: 16 }}>
            <ActionCard
              titleWidth="200px"
              icon={<Bag color="primary" />}
              title="My Trips"
              caption="Quickly find your booking reservations"
              isIconRounded={false}
              onClick={trackMyTrips}
            />
            <ActionCard
              titleWidth="200px"
              icon={<Help />}
              title="Help Center"
              isIconRounded={false}
              caption="We are always Here for you - reach us 24hrs a day, 7 days a week"
              onClick={trackHelpCenter}
            />
          </Flex>
        </Experiment>
      </ConditionalRender>
      <EmailSignUpToast sourceId="LANDING_HOME_TOAST_MWEB" isMobile />
    </Container>
  )
}
